const EmailKeys = { 
    serviceId: "service_p5x1ebd",
    templateId: "template_raxkfqj",
    publicId: "K8LNCdCx3fgyl2Zd6",
};

module.exports = EmailKeys;